// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const BlockedReasonSchema = z.enum(['server_unreachable','waf','rate_limit','anti_bot_system','authentication_failure','credential_disabled','tool_or_environment_error','missing_feature_access','missing_artifacts','guardrails','content_filter','untested','out_of_scope'] as const);

export type BlockedReasonType = `${z.infer<typeof BlockedReasonSchema>}`

export default BlockedReasonSchema;
